export const PROCESSING_FACILITY_NOT_FOUND = 'processing_facility_not_found';
